/** Company has sunbed session waiting list enabled (`is_sunbed_waiting_list` on company/settings). */
export function hasSunbedWaitingListEnabled(user: unknown): boolean {
  const raw = (user as { company?: { is_sunbed_waiting_list?: unknown } } | null)?.company
    ?.is_sunbed_waiting_list;
  if (raw === true || raw === 1 || raw === "1" || raw === "active") return true;
  if (typeof raw === "string") {
    const normalized = raw.trim().toLowerCase();
    return normalized === "true" || normalized === "yes" || normalized === "on";
  }
  return false;
}
